export default __webpack_public_path__ + "static/media/cpu.d9a5b0cf.svg";